/* eslint-disable no-barrel-files/no-barrel-files -- This package exposes types for ./userVoices so this file must remain a barrel. */
import { SampleAudioFileStatus, SampleFileFailureReason, TextToSpeechProviderName, VoiceFailureReason, VoiceStatus, VoiceType, } from "@next-platform/packages-ts-types";
export { SampleAudioFileStatus, SampleFileFailureReason, TextToSpeechProviderName, VoiceFailureReason, VoiceStatus, VoiceType, };
export var UserVoiceActions;
(function (UserVoiceActions) {
    UserVoiceActions["CLONE_USER_VOICE"] = "userVoices/clone";
    UserVoiceActions["RESUME_USER_VOICE"] = "userVoices/resume";
    UserVoiceActions["GET_USER_VOICES"] = "userVoices/getAll";
    UserVoiceActions["GET_USER_VOICE_BY_ID"] = "userVoices/getById";
    UserVoiceActions["UPDATE_USER_VOICE"] = "userVoices/update";
    UserVoiceActions["DELETE_USER_VOICE"] = "userVoices/delete";
    UserVoiceActions["APPROVE_USER_VOICE"] = "userVoices/approve";
    UserVoiceActions["MARK_VOICE_PROCESSING"] = "userVoices/markProcessing";
})(UserVoiceActions || (UserVoiceActions = {}));
export var UserVoiceFlows;
(function (UserVoiceFlows) {
    UserVoiceFlows["GET_VOICES"] = "GetVoices";
    UserVoiceFlows["GET_VOICE_BY_ID"] = "GetVoiceById";
    UserVoiceFlows["CLONE_VOICE"] = "CloneVoice";
    UserVoiceFlows["RESUME_VOICE"] = "ResumeVoice";
    UserVoiceFlows["UPDATE_VOICE"] = "UpdateVoice";
    UserVoiceFlows["DELETE_VOICE"] = "DeleteVoice";
    UserVoiceFlows["APPROVE_VOICE"] = "ApproveVoice";
})(UserVoiceFlows || (UserVoiceFlows = {}));
